import { createAction } from '@reduxjs/toolkit';
import {
  EmployeeLogin,
  EmployeeRegister,
  ForgotPassoword,
  Login,
  Otp,
  Register,
} from '../Services/constant/serviceType';
import { NavigateFunction } from 'react-router-dom';
import { User } from './constants/actionTypes';

export const handleLoginRequest = createAction<{
  payload: Login,
  navigate: NavigateFunction
}>('LOGIN_REQUEST');
export const handleEmployeeLoginRequest = createAction<{
  payload: Login,
  navigate: NavigateFunction
}>('EMPLOYEE_LOGIN_REQUEST');
export const handleCreateEmployeeRequest = createAction<{
  payload: EmployeeRegister,
  navigate: NavigateFunction
}>('CREATE_EMPLOYEE_REQUEST');
export const handleEmployeeEmailRequest = createAction<{
  payload: EmployeeLogin,
  navigate: NavigateFunction
}>('EMPLOYEE_REGISTER_REQUEST');
export const handleEmployeeOtpRequest = createAction<{
  payload: Otp,
  navigate: NavigateFunction
}>('SEND_EMPLOYEE_OTP_REQUEST');
export const handleLoginSuccess = createAction<{ token: string, email: string }>('LOGIN_SUCCESS');
export const handleEmployeeSteps = createAction<{ steps: string, email: string  }>('EMPLOYEE_STEP_REQUEST');
export const handleChangeSteps = createAction<{ steps: string  }>('CHANGE_STEP_REQUEST');
export const handleSaveCompanyId = createAction<{ id: number  }>('SAVE_COMPANY_ID');
export const handleSaveUserType = createAction<string>('SAVE_USER_TYPE');

export const handleLoginFailure = createAction<string>('LOGIN_FAILURE');
export const handleLogoutRequest = createAction('REQUEST_LOGOUT');
export const handleLogout = createAction('LOGOUT');
export const handleRegisterRequest = createAction<{
  payload: Register,
}>('REGISTER_REQUEST');
export const handleRegisterSuccess = createAction<{ token: string }>('REGISTER_SUCCESS');
export const handleSuccess = createAction('SUCCESS');
export const handleNextPage = createAction('NEXT_PAGE');
export const handleFailure = createAction('FAILURE');
export const handleForgotPassword = createAction<ForgotPassoword>('FORGOT_PASSWORD');
export const handleOtpRequest = createAction<{
  payload: Otp,
  navigate: NavigateFunction
}>('SEND_OTP_REQUEST');
export const resetOtpState = createAction('RESET_OTP_STATE');


export const handleSaveUserData = createAction<User>('SAVE_USER_DATA');
export const handlePageLoading = createAction<boolean>('PAGE_LOADER');
export const handleSaveWalletData = createAction<boolean>('SAVE_WALLET_DATA');
export const handleSaveBank = createAction<boolean>('SAVE_BANK');

